import { makeStyles } from '@fluentui/react-components';
import heroImage from '@/assets/copilot-hero.webp';

const useStyles = makeStyles({
  // Anchored to the AppShell padding box (the shell is the nearest positioned
  // ancestor): 32px top/right inset per Figma V4.6, 560px wide at the 1600
  // design viewport. The shell caps at 1600px, so beyond that the viewport-
  // relative 35vw always clamps to the designed 560px. Pages that render the
  // panel reserve flow height for it (minHeight ~910) so the shell footer
  // clears its bottom edge.
  hero: {
    position: 'absolute',
    top: '32px',
    right: '32px',
    width: 'clamp(380px, 35vw, 560px)',
    height: 'auto',
    borderRadius: '8px',
    '@media (max-width: 900px)': {
      display: 'none',
    },
  },
});

/** The Copilot hero render shown on Landing, Partner Details, and Overview. */
export function HeroPanel(): React.ReactElement {
  const styles = useStyles();
  return <img className={styles.hero} src={heroImage} alt="" aria-hidden="true" />;
}
